import {Component, Inject, OnInit} from '@angular/core';
import {UtilsService} from "../../shared/utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AssetsViewUsersFilters} from "./assets-view-users-filter.interface";

@Component({
  selector: 'app-assets-view-users-filter',
  templateUrl: './assets-view-users-filter.component.html',
  styleUrls: ['./assets-view-users-filter.component.scss']
})
export class AssetsViewUsersFilterComponent implements OnInit {
  filters: AssetsViewUsersFilters = {
    trade: '',
    trades: []
  } as AssetsViewUsersFilters;

  constructor(
    private utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetsViewUsersFilterComponent>
  ) { }

  ngOnInit(): void {
    this.getTrades();

    this.filters.trade = this.data['trade'];
  }

  /**
   * Retrieves list of trades asynchronously and sets it in filters object.
   *
   * @return {Promise<void>} A Promise that resolves once trades are obtained and set.
   */
  private async getTrades(): Promise<void> {
    this.filters.trades = await this.utils.getTrades();
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.trade = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      trade: this.filters.trade
    }

    this.dialogRef.close(response);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
